<template lang="pug">
  v-dialog(
    v-model="dialog"
    v-bind="extendAttrs"
    v-on="extendListeners"
    attach
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")

    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")

    v-card.ui-design.ui-bright(
      v-bind="extendCardAttrs"
      style="overflow: hidden"
      rounded="xxl"
      elevation="0"
    )
      slot(
        v-if="!hideHeader"
        name="header"
        v-bind="{ close }"
      )
        v-card-title.pa-8.pb-6.mb-2.word-break-normal.flex-nowrap
          h2(v-if="title" v-bind="extendTitleAttrs") {{ title }}
          v-spacer
          slot(
            v-if="closeIcon"
            name="header.close"
            v-bind="{ close }"
          )
            v-btn(icon @click="close")
              v-icon(color="redesignBlack" size="20") {{ closeIcon }}
        v-card-subtitle.pa-8.pt-0.pb-6.mt-n7(
          v-if="description"
          class="ui-neutral--text"
        ) {{ description }}

      .d-flex.flex-column.pa-8.pt-0.overflow-y-auto(v-if="!hideContent")
        slot(name="content" v-bind="{ close }")

      v-card-actions.pa-8.pt-0(v-if="!hideActions")
        slot(name="actions" v-bind="{ close }")
</template>

<script>
export default {
  name: 'EvDialog',
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    hideHeader: { type: Boolean, default: false },
    hideContent: { type: Boolean, default: false },
    hideActions: { type: Boolean, default: false },
    maxHeight: { type: String, default: '90%' },
    closeIcon: { type: String, default: '$ui-close' },
  },
  data() {
    return {
      dialog: this.value,
      isClosing: false,
    };
  },
  computed: {
    styleList() {
      const { $attrs } = this;

      return {
        ...$attrs.style,
        '--dialog-max-height': this.maxHeight,
      };
    },
    extendAttrs() {
      const attrs = { ...this.$attrs };
      delete attrs['card-attrs'];
      delete attrs['title-attrs'];
      return {
        'max-width': 600,
        'overlay-opacity': 0.3,
        scrollable: true,
        ...attrs,
        style: this.styleList,
      };
    },
    extendCardAttrs() {
      return { ...(this.$attrs['card-attrs'] || {}) };
    },
    extendTitleAttrs() {
      return { ...(this.$attrs['title-attrs'] || {}) };
    },
    extendListeners() {
      return {
        ...this.$listeners,
        input: (val) => this.$emit('input', val),
      };
    },
  },
  watch: {
    value(value) {
      if (value) {
        this.isClosing = false;
        this.dialog = true;
        return;
      }
      this.close({ force: true });
    },
    dialog(value) {
      if (!value && !this.isClosing) this.close();
    },
  },
  methods: {
    close(options = {}) {
      if (this.isClosing) return;
      this.isClosing = true;
      this.$emit('before:close');
      this.dialog = false;
      this.$nextTick(() => {
        this.$emit('close', { force: options?.force === true });
      });
    },
  },
};
</script>
